import { useState } from 'react'

import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import cover_placeholder from 'assets/images/home/cover_placeholder.png'
import ImgInCircle from 'components/UI/ImgInCircle/ImgInCircle'
import ProfileImageModal from 'components/UI/Modal/ProfileImage/ProfileImageModal'
import { AllIcons } from 'helpers/allIcons'
import { Icons } from 'helpers/icons'

interface Props {
    cover: string | null
    id: string
    avatar: string | null
    display_name: string
    follower_count: number
    friend_count: number
    username: string
    hideUpload?: boolean
}

const CreatorProfileHolder = ({
    cover,
    id,
    avatar,
    display_name,
    follower_count,
    friend_count,
    username,
    hideUpload = false
}: Props) => {
    const [avatarModalOpen, setAvatarModalOpen] = useState(false)
    const [coverModalOpen, setCoverModalOpen] = useState(false)

    const { t } = useTranslation()

    return (
        <>
            {avatarModalOpen && (
                <div
                    className={'modal modal__uploadImages modal--active'}
                    // onClick={(e: any) => e.target === e.currentTarget && clearModal()}
                >
                    <div className={'modal__card '}>
                        <div className='modal__title'>
                            {t('profileImage')}
                            <img
                                className='modal__card__withoutTitle__close'
                                onClick={() => {
                                    setAvatarModalOpen(false)
                                }}
                                src={Icons.close}
                                alt={t('close')}
                            />
                        </div>
                        <ProfileImageModal
                            closeNestedModal={() => {
                                setAvatarModalOpen(false)
                            }}
                        />
                    </div>
                </div>
            )}
            {coverModalOpen && (
                <div
                    className={'modal modal__uploadImages modal--active'}
                    // onClick={(e: any) => e.target === e.currentTarget && clearModal()}
                >
                    <div className={'modal__card '}>
                        <div className='modal__title'>
                            {t('coverImage')}
                            <img
                                className='modal__card__withoutTitle__close'
                                onClick={() => {
                                    setCoverModalOpen(false)
                                }}
                                src={Icons.close}
                                alt={t('close')}
                            />
                        </div>
                        <ProfileImageModal
                            isCover={true}
                            closeNestedModal={() => {
                                setCoverModalOpen(false)
                            }}
                        />
                    </div>
                </div>
            )}
            <Cover
                className='profilecover'
                style={{
                    backgroundImage: `url(${cover || cover_placeholder})`
                }}
            ></Cover>
            <div className='profileholder profileholder__profile'>
            <ImgInCircle
            id={id}
            type='profile'
            hasLoader={true}
            verificationMode={true}
            hasCamera={!hideUpload}
            cameraFn={() => setAvatarModalOpen(true)}
            >
            {avatar ? (
                <img
                src={avatar}
                alt={t('profileImage')}
                onError={(e) => {
                    e.currentTarget.src = AllIcons.user_placeholder
                }}
                />
            ) : (
                <div className='profileholder__profile__placeholder'>
                <img src={AllIcons.user_placeholder} alt={t('placeholder')} />
                </div>
            )}
            </ImgInCircle>
                {!hideUpload && (
<div
    className='iic__camera iic__camera__cover iic__camera--verification-cover'
                    onClick={() => {
                        setCoverModalOpen(true)
                    }}
                >
                    <img src={Icons.camera} alt={t('changeCover')} />
                </div>
                )}
                <div className='profileholder__info'>
                    <p className={'profileholder__name'}>{display_name}</p>
                    <div className='profileholder__username'>
                        <p className='profileholder__username--followers'>
                            <span>{follower_count}</span> {t('Fans')}
                        </p>
                        <div className='profileholder__username--border'></div>
                        <p className='profileholder__username--friends'>
                            <span>{friend_count}</span> {t('friends')}
                        </p>
                        <div className='profileholder__username--border'></div>
                        <p className='profileholder__username--name'>
                            @{username}
                        </p>
                    </div>
                    {/* <p className="profileholder__quote">
            <img src={Icons.quotes} alt="quotes" /> One day or day one, you
            decide
          </p> */}
                </div>
            </div>
        </>
    )
}
const Cover = styled.div`
    position: relative;
    border-top-left-radius: 2rem;
    border-top-right-radius: 2rem;
    margin-top:2rem;
    overflow: hidden;
    width: 100%;
    height: 170px; // or whatever fits your design
    background-size: cover;
    background-position: center;
`

export default CreatorProfileHolder
